import React, { useState } from 'react';
import { Box, VStack, HStack, Text, Button, Heading, Flex, Icon } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { StarIcon } from '@chakra-ui/icons';
import { registrarAvaliacao } from '../api/mockApi';

const MotionBox = motion(Box);

const FeedbackScreen = ({ clientName, onBack, onComplete }) => {
  const [rating, setRating] = useState(0);
  const [hoveredRating, setHoveredRating] = useState(0);
  const [comment, setComment] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (rating === 0) return;
    
    try {
      setIsSubmitting(true);
      await registrarAvaliacao(clientName, rating, comment);
      onComplete();
    } catch (error) {
      console.error('Erro ao enviar avaliação:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <MotionBox
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      height="100vh"
      width="100%"
      bg="black"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      padding={8}
    >
      <VStack spacing={8} width="100%" maxWidth="600px">
        <Heading size="lg" textAlign="center">Como foi sua experiência?</Heading>
        
        <Text fontSize="lg" textAlign="center">
          Sua opinião é muito importante para continuarmos melhorando nossos serviços.
        </Text>
        
        {/* Sistema de Estrelas */}
        <HStack spacing={4} justifyContent="center">
          {[1, 2, 3, 4, 5].map((star) => (
            <MotionBox
              key={star}
              whileHover={{ scale: 1.2 }}
              whileTap={{ scale: 0.9 }}
              cursor="pointer"
              onClick={() => setRating(star)}
              onMouseEnter={() => setHoveredRating(star)}
              onMouseLeave={() => setHoveredRating(0)}
            >
              <Icon
                as={StarIcon}
                boxSize={12}
                color={(hoveredRating || rating) >= star ? "yellow.400" : "whiteAlpha.300"}
              />
            </MotionBox>
          ))}
        </HStack>
        
        <Text fontSize="xl" fontWeight="bold" color="yellow.400">
          {rating === 1 && "Ruim"}
          {rating === 2 && "Regular"}
          {rating === 3 && "Bom"}
          {rating === 4 && "Muito Bom"}
          {rating === 5 && "Excelente!"}
        </Text>
        
        {/* Área de comentário (simplificada para o totem) */}
        <Box
          as="textarea"
          placeholder="Comentários adicionais (opcional)"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          height="120px"
          width="100%"
          p={4}
          borderRadius="md"
          bg="whiteAlpha.200"
          color="white"
          borderColor="whiteAlpha.300"
          _focus={{ borderColor: "yellow.400" }}
          resize="none"
        />
        
        <Flex width="100%" justifyContent="space-between">
          <Button
            variant="outline"
            onClick={onBack}
            isDisabled={isSubmitting}
          >
            Voltar
          </Button>
          
          <Button
            bg="yellow.400"
            color="black"
            _hover={{ bg: "yellow.500" }}
            onClick={handleSubmit}
            isDisabled={rating === 0 || isSubmitting}
            isLoading={isSubmitting}
          >
            Enviar Avaliação
          </Button>
        </Flex>
      </VStack>
    </MotionBox>
  );
};

export default FeedbackScreen;
